import { useNavigate } from "react-router-dom";
import { Gauge, ListChecks, Send, Sliders } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

type EmailAdminTile = {
  title: string;
  description: string;
  path: string;
  Icon: LucideIcon;
};

const EMAIL_ADMIN_TILES: EmailAdminTile[] = [
  {
    title: "Quota",
    description: "Resend dag/maand verbruik, waarschuwingen en Mailjet overflow.",
    path: "/admin/email/quota",
    Icon: Gauge,
  },
  {
    title: "Logs",
    description: "Sent and failed messages, unfinished submissions, live tail.",
    path: "/admin/email/logs",
    Icon: ListChecks,
  },
  {
    title: "Provider settings",
    description: "Choose Mailjet or Resend for outbound mail.",
    path: "/admin/email/provider",
    Icon: Sliders,
  },
  {
    title: "Test mail",
    description: "Send a test message through the active provider.",
    path: "/admin/email/test",
    Icon: Send,
  },
];

const EmailAdminHub = () => {
  const navigate = useNavigate();

  return (
    <div className="flex-1 min-h-0 overflow-y-auto p-6 space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">Email</h1>
        <p className="text-gray-600 dark:text-gray-400">
          Delivery logs, provider configuration, and test sends.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {EMAIL_ADMIN_TILES.map(({ title, description, path, Icon }) => (
          <button
            key={path}
            type="button"
            onClick={() => navigate(path)}
            className="text-left rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            <Card className="h-full transition-colors hover:border-primary hover:bg-accent/30">
              <CardHeader className="space-y-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-md bg-blue-50 text-blue-600 dark:bg-blue-950/50 dark:text-blue-300">
                  <Icon className="h-5 w-5" aria-hidden />
                </div>
                <div>
                  <CardTitle className="text-base">{title}</CardTitle>
                  <CardDescription>{description}</CardDescription>
                </div>
              </CardHeader>
              <CardContent className="pt-0">
                <span className="text-sm text-primary">Open</span>
              </CardContent>
            </Card>
          </button>
        ))}
      </div>
    </div>
  );
};

export default EmailAdminHub;
